import {
	Button,
	Col,
	Form,
	Input,
	InputNumber,
	Row,
	notification,
	Space,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { PlusOutlined } from "@ant-design/icons";

const BatchedDataModal = ({ cogs, jobs, onSuccess }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		builData();
	}, []);

	const builData = () => {
		setInitialValues({ cogs: cogs });
		setLoading(false);
	};

	const saveBatchedData = async (datas) => {
		try {
			setLoading(true);
			let currentCogs = [];

			datas.cogs.map((cog) => {
				currentCogs.push({
					cog: cog._id,
					total: cog.total,
				});
			});

			const formData = {
				cogs: currentCogs,
				jobs: jobs,
			};

			const url = api + "/job/update/batched/alkon";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, formData);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					setLoading(false);
					onSuccess();
				}, 1000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update jobs");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		saveBatchedData(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.List name="cogs">
							{(fields) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Space
											key={key}
											style={{
												display: "flex",
												marginBottom: 8,
											}}
											align="baseline"
										>
											<Form.Item
												{...restField}
												name={[name, "_id"]}
												label="ID"
												rules={[
													{
														required: true,
														message: "ID is requiered",
													},
												]}
												hidden
											>
												<Input
													style={{
														width: "100%",
													}}
													size="large"
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "material"]}
												label="Material"
												rules={[
													{
														required: true,
														message: "Material is requiered",
													},
												]}
											>
												<Input
													style={{
														width: "100%",
													}}
													size="large"
													disabled
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "total"]}
												label="Total"
												rules={[
													{
														required: true,
														message: "Missing total",
													},
												]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													formatter={(value) =>
														`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
													}
													parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
												/>
											</Form.Item>
										</Space>
									))}
								</>
							)}
						</Form.List>
					</Col>
				</Row>

				<Button
					type="primary"
					htmlType="submit"
					loading={loading}
					size="large"
					icon={<PlusOutlined />}
				>
					Add Batched
				</Button>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			<CustomForm />
		</>
	);
};

export default BatchedDataModal;
